const ShapeOne = () => {
  return <div id="shape-one"></div>;
};

export default ShapeOne;
